/* file description */
import { Modal } from 'antd';
import { ButtonLayout, ModalFullLayout } from '@/asset/AssetTask/templates/Cascade/components';
import SpQiankun from '@/components/sp-qiankun';
import React, { forwardRef, useState } from 'react';
import { getModule, getField, getBizComponent } from '@/asset/AssetField/utils';
import moduleMapAsset from '@/common/asset-apis/useModelMapAseet';
import { transformComponentsTypeToKind, customizer } from '@/common/asset-apis/getAssetModuleByRequest';
import SPTableWithModel from '@/components/SPTableWithModel';
import { SPTableBaseMode } from '@/components/SPTableBase/effect';
import { getApiData } from '@/common/asset-apis/assetModel';
import { Api } from '@cui/req';

export interface SpBusinessBtnsType {
  btnInfo: any;
  isRow?: boolean;
  openCallBack?: () => void;
  utils: any;
  record: any;
  moduleID: string;
  openDrawer?: boolean;
}

const TopTableBtn: React.FC<SpBusinessBtnsType> = forwardRef((props, ref) => {
  const { btnInfo, addTableData, moduleID, moduleList, addTableDataList, allData, metaInfoByRule, isMobile } = props;
  const { transformAssetFieldType } = moduleMapAsset();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const [bizConfig, setBizConfig] = useState<any>({});
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRow, setSelectedRow] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);

  const saveCb = (tag: boolean, result: any, values: any) => {
    if (tag) {
      if (result?.data?.queryData?.record?.[0]?.value?.[btnInfo?.modalValue]) {
        let extraData: Record<any, any> = {};
        if (btnInfo?.extraData) {
          extraData = (new Function("return " + btnInfo?.extraData))();
        }
        addTableData(moduleID, { ...extraData, [btnInfo?.moduleValue]: result?.data?.queryData?.record?.[0]?.value?.[btnInfo?.modalValue] });
      }
      setIsModalOpen(false);
    }
  };

  const getModalConfig = async() => {
    let fieldMeta: any;
    let module: any;
    if (moduleID && btnInfo?.moduleValue) {
      module = await getModule(moduleID);
      fieldMeta = await getField(module, btnInfo?.moduleValue);
      fieldMeta.kind = transformAssetFieldType(fieldMeta.dataType);
    }
    const fields = moduleList?.find((item: any) => item.handle === moduleID)?.fields || [];
    const componentsCode = fields?.find((item: any) => item.name === btnInfo?.moduleValue)?.componentsCode;
    const roleConfig = metaInfoByRule?.[moduleID]?.fields?.find((item: any) => item.dataIndex === btnInfo?.moduleValue)?.bizComponent?.options || {};
    if (componentsCode) {
      fieldMeta = fieldMeta || {};
      const component = await getBizComponent(componentsCode);
      const bizConfig = _.mergeWith({}, component.options, fieldMeta.options?.componentsOptions, roleConfig, customizer);
      fieldMeta = {
        ...fieldMeta,
        bizConfig,
      };
      // prefilter拼接
      if (!fieldMeta.bizConfig.prefilter && fieldMeta.bizConfig.filterField && fieldMeta.bizConfig.filterFieldValue) {
        fieldMeta.bizConfig.prefilter = `${fieldMeta.bizConfig.filterField} = '${fieldMeta.bizConfig.filterFieldValue}'`;
      }
      setBizConfig(fieldMeta.bizConfig);
      if (fieldMeta?.bizConfig?.isOpenApi) {
        getApiDataList(fieldMeta.bizConfig);
      }
      setSelectOpen(true);
    }
  };

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  const getApiDataList = (option: any) => {
    let headData: Record<any, any> = {};
    const apiParams: Record<any, any> = {};
    if (allData) {
      Object.keys(allData).forEach((key: any) => {
        if (!Array.isArray(allData[key])) {
          headData = allData[key];
        }
      });
    }
    option?.apiKeyList?.forEach((item: any) => {
      if (item.isValueFromMainModule) {
        apiParams[item.apiKey] = headData?.[item.apiValueModule]
      }
    });
    getApiData(Api, option?.apiUrl, apiParams).then((res: any) => {
      const { set = [] } = res || {};
      const mapData = set.map((item: any) => {
        const converData = convert(item);
        return converData;
      });
      setTableData(mapData);
    });
  };

  const handleColumns = () => {
    const { tableColumn, searchColumn = [] } = bizConfig || {};
    const targetTableColumns =
      tableColumn?.map((itemKey: string) => {
        const resColumn: Record<string, any> = {
          dataIndex: itemKey,
        };
        if (!searchColumn?.includes(itemKey)) {
          resColumn.search = false;
        } else {
          resColumn.searchOptions = {};
          resColumn.searchOptions.sequence = searchColumn.findIndex((item: string) => item === itemKey);
        }
        return resColumn;
      }) || [];
    return targetTableColumns;
  };

  // const onSelectChange = (_selectedIDList: React.Key[], selectedRecordList: Array<Record<any, any>>) => {
  //   console.log(566, selectedRowKeys, _selectedIDList)
  //   setSelectedRowKeys([...new Set([...selectedRowKeys, ..._selectedIDList])]);
  //   // setSelectedRowKeys(_selectedIDList);
  //   setSelectedRow(selectedRecordList);
  // };

  const onSelect = (record, selected, selectedRows) => {
    const newSelectedRowKeys: any = [];
    const newSelectedRow: any = [];
    if (selected) {
      setSelectedRowKeys([...new Set([...selectedRowKeys, record._id])]);
      setSelectedRow([...new Set([...selectedRow, record])]);
    }
    if (!selected) {
      selectedRowKeys.forEach((item: any) => {
        if (item !== record._id) {
          newSelectedRowKeys.push(item);
        }
      });
      selectedRow.forEach((item: any) => {
        if (record._id !== item._id) {
          newSelectedRow.push(item);
        }
      });
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRow(newSelectedRow);
    }
  };

  const onSelectAll = (selected, selectedRows, changeRows) => {
    const newSelectedRowKeys: any = [];
    const newSelectedRow: any = [];
    if (selected) {
      changeRows.forEach((item: any) => {
        newSelectedRowKeys.push(item._id);
      });
      setSelectedRowKeys([...new Set([...selectedRowKeys, ...newSelectedRowKeys])]);
      setSelectedRow([...new Set([...selectedRow, ...changeRows])]);
    }
    if (!selected) {
      selectedRowKeys.forEach((item: any) => {
        if (changeRows?.every((data: any) => data._id !== item)) {
          newSelectedRowKeys.push(item);
        }
      });
      selectedRow.forEach((item: any) => {
        if (changeRows?.every((data: any) => data._id !== item._id)) {
          newSelectedRow.push(item);
        }
      });
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRow(newSelectedRow);
    }
  };

  // const clickRow = (key: any, record: any) => {
  //   const keysList = [...selectedRowKeys];
  //   if (keysList.indexOf(key) >= 0) {
  //     keysList.splice(keysList.indexOf(key), 1);
  //   } else {
  //     keysList.push(key);
  //   }
  //   setSelectedRowKeys(keysList);
  // };

  const onOk = () => {
    const dataList: any[] = [];
    const { showFields = [], options = [] } = bizConfig;
    selectedRow.forEach((item: any) => {
      if (item?.[bizConfig?.value]) {
        const values: Record<any, any> = {};
        // 联动字段
        options.forEach((option: { moduleField: any; linkField: any }) => {
          values[option?.moduleField] = item?.[option?.linkField];
        });
        // 联动展示字段
        showFields.forEach((showField: { key: any; realLabel: any }) => {
          const setName = `${btnInfo?.moduleValue}_LINK_${showField?.key}`;
          values[setName] = item?.[showField?.key];
        });
        dataList.push({
          ...values,
          [btnInfo?.moduleValue]: item?.[bizConfig?.value],
        });
      }
    });
    addTableDataList(moduleID, dataList);
    setSelectOpen(false);
    setSelectedRowKeys([]);
    setSelectedRow([]);
  };

  return (
    <>
      <ButtonLayout
        style={{ marginRight: '8px' }}
        key="index"
        type="primary"
        onClick={() => {
          if (btnInfo.type === 'selectModal') {
            getModalConfig();
          } else {
            setIsModalOpen(true);
          }
        }}
      >
        {btnInfo.text}
      </ButtonLayout>
      {isModalOpen &&
        <ModalFullLayout
          title="新增"
          visible
          onCancel={() => setIsModalOpen(false)}
          width="70vw"
          footer={null}
          destroyOnClose
          maskClosable={false}
        >
          <SpQiankun
            saveCb={saveCb}
            modal
            routeUrl={btnInfo.url}
          />
        </ModalFullLayout>
      }
      {selectOpen &&
        <ModalFullLayout
          title="选择"
          visible
          onCancel={() => setSelectOpen(false)}
          width="70vw"
          okText="确认选择"
          cancelText="取消"
          destroyOnClose
          onOk={onOk}
          maskClosable={false}
        >
          <SPTableWithModel
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys,
              // onChange: onSelectChange,
              onSelect,
              onSelectAll,
            }}
            // onRow={(record: any) => ({
            //   onClick: () => {
            //     clickRow(record._id, record);
            //   },
            // })}
            API={{
              FetchAPI: Api,
            }}
            floadSearch
            selectedRows={selectedRow}
            search={!bizConfig?.isOpenApi}
            value={bizConfig?.isOpenApi ? tableData : undefined}
            requestParams={{
              sort: bizConfig?.preSort || '',
            }}
            moduleID={bizConfig?.dataKey}
            namespaceID={bizConfig?.treeId}
            filter={bizConfig?.isFilter ? (bizConfig?.dataType || bizConfig?.prefilter || '') : ''}
            columns={handleColumns()}
            tableBaseMode={SPTableBaseMode.VIEW}
            isMobile={isMobile}
          />
        </ModalFullLayout>
      }
    </>
  );
});

export default TopTableBtn;
